import React from 'react';
import { walkClaimText } from '../../../../lib/walkClaimText';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const ConservationSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.waterAnalysis?.waterConservation;
  return (
    <SectionShell label={label} hasData={!!text}>
      {text && (
        <EditorialSubsection theme={theme} label="Water Conservation">
          {walkClaimText(text, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
